<div class="page-outer-wrapper">
  <div class="page-header">
    <div class="hamburger">
      <a routerLink="/overwatch"><img src="/assets/images/apple-touch-icon-72x72-precomposed.png" height="28" width="28"></a>
    </div>
    <div id="nav-bar" class="nav-bar">
    </div>
  </div>
  <div class="page-content-background">
    <div class="page-content">

      <div class="project-page-content">

        <!-- colum for full project details -->
        <div class="project-page-wrapper">

          <!-- header row -->
          <div class="project-page-header-row">

            <!-- project logo -->

            <span class="project-list-row-cell logo-cell" style="min-width: 140px;">

              <p-inplace
                [style.width]="300"
                [disabled]="!isAdmin()"
                #inplace3
                class="prjclass-logo-{{project.id}} light"
                closable="closable"
                (onDeactivate)="prjEditLogoDeactivate(project.id, inplace3)"
                (onActivate)="prjEditLogoActivate(project.id, inplace3)"
                (keyup)="prjEditLogoKey($event, project.id, inplace3)">

                <ng-template pTemplate="display">
                  <img src="{{project.logo_url ? project.logo_url : '/assets/images/default-project-logo.png'}}" referrerpolicy="no-referrer">
                </ng-template>

                <ng-template pTemplate="content">
                  <input type="text" value="{{project.logo_url}}" pInputText>
                </ng-template>

              </p-inplace>

            </span>

            <!-- project key -->

            <span class="project-list-row-cell">
              <span style="display: inline-block; margin-left: 12px; margin-right: 12px; ">{{project.key}}</span>
           </span>

            <!-- project's org, its name,  description -->

            <span class="project-list-row-cell">

              <span style="font-size: 11px; font-weight: normal; color: grey;">
                <a class="project-list-row-link" href="/organization/{{project.organization.key}}"><b>{{project.organization.key}}</b> - {{project.organization.name}}</a>
              </span>

              <span style="font-size: 24px; color: black; font-weight: normal; display: block;">

              <p-inplace
                #inplace1
                [disabled]="!isAdmin()"
                class="prjclass-name-{{project.id}} light"
                closable="closable"
                (onDeactivate)="prjEditNameDeactivate(project.id, inplace1)"
                (onActivate)="prjEditNameActivate(project.id, inplace1)"
                (keyup)="prjEditNameKey($event, project.id, inplace1)">

                <ng-template pTemplate="display">
                   <b>{{project.name}}</b>
                </ng-template>

                <ng-template pTemplate="content">
                  <input type="text" value="{{project.name}}" pInputText>
                </ng-template>

              </p-inplace>

              </span>

              <span style="font-size: 11px; font-weight: normal; color: grey;">

                <p-inplace
                  [disabled]="!isAdmin()"
                  #inplace2
                  class="prjclass-desc-{{project.id}} light"
                  closable="closable"
                  (onDeactivate)="prjEditDescDeactivate(project.id, inplace2)"
                  (onActivate)="prjEditDescActivate(project.id, inplace2)"
                  (keyup)="prjEditDescKey($event, project.id, inplace2)">

                  <ng-template pTemplate="display">
                    <i style="font-size: 14px;">{{project.description}}</i>
                  </ng-template>

                  <ng-template pTemplate="content">
                    <input type="text" value="{{project.description}}" pInputText>
                  </ng-template>

                </p-inplace>

              </span>

            </span>

          </div>

          <div *ngIf="isAdmin()" class="projectaddmember">

            <!-- add new (random) project members -->

            <label style="margin-right: 8px;">Add Member:</label>
            <p-autoComplete
              [(ngModel)]="newUser"
              [suggestions]="searchUsers"
              (completeMethod)="search($event)"
              (onSelect)="addMember($event)"
              field="label"
              class="light">

              <ng-template let-match pTemplate="item">
                <div [innerHTML]="formatMatch(match.label)"></div>
              </ng-template>

            </p-autoComplete>

          </div>

          <div *ngIf="project.pending_users.length && isAdmin()" style="margin-top: 24px;" class="project-page-instructions-row">

            <h6>New Administrators?</h6>

            <user-list-component
              [editable]="isAdmin()"
              [pending]="true"
              [proj]="project"
              [users]="project.pending_users"
              (member_approve)="approve($event)"
              (member_approve_and_add)="approveAndLink($event)"
            >
            </user-list-component>

          </div>

          <!-- 3 columns, the subdivision selector, the members and the admins (read only) -->
          <div style="margin-top: 48px; width: 100%;" class="project-page-instructions-row">

            <div class="project-page-subs">

              <div *ngIf="allSubs.length">

                <subdivision-list-component [subdivisions]="allSubs" [editable]="isAdmin()" [proj]="project" mode="project"></subdivision-list-component>

              </div>

            </div>

            <div class="project-members">

              <h6>Members</h6>

              <user-list-component
                [editable]="isAdmin()"
                [proj]="project"
                [users]="project.members"
                (member_unlinked)="unlinkMember($event)"
              >
              </user-list-component>

            </div>

            <div class="project-admins">

              <h6>Administrators</h6>

              <user-list-component
                [editable]="false"
                [org]="project.organization"
                [users]="project.admins"
              >
              </user-list-component>

            </div>

            <div style="clear: both; height: 1px;"></div>

          </div>

          <!-- user instructions -->
          <div style="margin-top: 24px;" class="project-page-instructions-row">

            <p-accordion class="light">

              <p-accordionTab header="Help">

                <p>
                  Project details below, Administrators will also see
                  controls for editing, approving new users, or inviting new members.  All changes are
                  saved as you make them. To edit text fields, click for inline editing.
                </p>

              </p-accordionTab>

            </p-accordion>

          </div>

        </div>

      </div>

    </div>
    <div id="pano-footer" class="pano-footer"></div>
  </div>
</div>
